/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import axios from 'axios';
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
// router setup
import router from './routes/router';
import LoadScript from 'vue-plugin-load-script';
import Toast from 'vue-toastification';

import CryptoJS from "crypto-js";
Vue.use(LoadScript);
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueIntro);
// plugin setup
Vue.prototype.$baseUrl= process.env.VUE_APP_API_URL || 'https://api.train321.com/';
Vue.prototype.$downloadUrl= process.env.VUE_APP_API_DOWNLOAD_URL || 'https://api.train321.com/';

const SECRET_KEY = "Train321";
const _setItem = localStorage.setItem;
const _getItem = localStorage.getItem;
// testing
Storage.prototype.setItem = function (key, value) {
  try {
    const rawValue = typeof value === "string" ? value : JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(rawValue, SECRET_KEY).toString();
    return _setItem.call(this, key, encrypted);
  } catch (err) {
    console.warn("Encryption failed, saving as plain:", err);
    return _setItem.call(this, key, value);
  }
};

Storage.prototype.getItem = function (key) {
  const value = _getItem.call(this, key);


  if (!value) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (decrypted) {
     return decrypted
    }
  } catch {
    console.log(value);
    console.warn("Decryption failed, returning plain value");
  }
  return value;
  console.warn("Decryption failed, returning plain value");
};
console.log("Full Name:",
localStorage.getItem("hot-user-full-name"));
let headers = {
  authorization: 'Bearer '+localStorage.getItem("hot-token"),
  'content-type': 'application/json'
}

/** -- style sheet loading -- */
const currentPlatform = process.env.VUE_APP_COMPANY_NAME;
document.title = currentPlatform.toUpperCase().replace(/_/g, ' ');

let link = document.createElement('link');
link.rel = "stylesheet";
link.href = `/${currentPlatform.toLowerCase()}_custom.css`;
document.head.appendChild(link);

/** -- Set favicon based on platform -- */
const faviconMap = {
  'Taco_Cabana': 'taco-cabana.png',
  'NTG': 'ntg-logo.png'
};

const faviconUrl = faviconMap[currentPlatform] || 'taco-cabana.png';
let faviconLink = document.querySelector('link[rel="icon"]');
if (faviconLink) {
  faviconLink.href = faviconUrl;
} else {
  faviconLink = document.createElement('link');
  faviconLink.rel = 'icon';
  faviconLink.type = 'image/png';
  faviconLink.sizes = '96x96';
  faviconLink.href = faviconUrl;
  document.head.appendChild(faviconLink);
}

/** -- End style sheet loading -- */

Vue.prototype.$http = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://api.train321.com/',
    headers
});

// before a request is made start the nprogress
Vue.prototype.$http.interceptors.request.use(config => {
  NProgress.start();
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error);
});

// before a response is returned stop nprogress
Vue.prototype.$http.interceptors.response.use(response => {
  NProgress.done();
  return response
}, error => {
  NProgress.done();
  return Promise.reject(error);
});
/* eslint-disable no-new */


/** scorm file uploading progress */
import 'vue-toastification/dist/index.css';
 
 Vue.use(Toast, {
   position: 'top-right',
   timeout: false, // don't auto-close unless you want to
   closeOnClick: true,
   pauseOnHover: true,
   draggable: true,
   // closeButton: true,
   showCloseButtonOnHover: false, // :white_check_mark: always visible
   closeButton: "button", // :white_check_mark: explicitly use default button
   // showCloseButtonOnHover: true,
 });
/** end scorm file uploading progress */






new Vue({
  el: '#app',
  render: h => h(App),
  router
});
